<template>
  <div class="w100p">
    <div class="display-flex align-center w100p text-violet">
      <div class="progress-bar w100p h1 br0-5">
        <div class="mr1 h1 br0-5" :style="style"></div>
      </div>
      <span class="ml1 f1-3">{{ value }}<span v-if="value !== 'NA'">%</span></span>
    </div>
    <div class="f1-2 text-left capitalize mt1">
      <span class="text-grey">{{ progressTitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bh-progress-bar',
  props: {
    value: {
      type: Number | String,
      default: 30
    },
    progressColor: {
      type: String,
      default: '#5764B3'
    },
    progressTitle: {
      type: String,
      default: 'Accuracy'
    }
  },
  computed: {
    style() {
      return {
        background: this.progressColor,
        width: this.value !== 'NA' ? `${this.value}%` : 0
      }
    }
  }
}
</script>

<style scoped>
.progress-bar {
  background: #e2e5f4;
}
</style>
